import { base } from 'viem/chains';
import { OnchainKitProvider } from '@coinbase/onchainkit';
import '@coinbase/onchainkit/styles.css';

export function RootProvider({ children }) {
  return (
    <OnchainKitProvider 
      chain={base} 
      apiKey={process.env.NEXT_PUBLIC_ONCHAINKIT_API_KEY} 
      // miniKit={{
      //   enabled: true,
      //   autoConnect: true,
      //   notificationProxyUrl: '/api/notify',
      // }}
      config={{
        appearance: {
          name: 'Jesse and the Cybernauts',
          logo: 'https://cybernauts.fun/assets/images/logo512.webp',
          mode: 'auto',
          theme: 'base',
        },
        wallet: {
          display: 'modal',
        },
        paymaster: process.env.PAYMASTER_ENDPOINT,
        analytics: true,
      }}
    >
      {children}
    </OnchainKitProvider>
  );
}